/** @jsxImportSource @emotion/react */
import { useTranslation } from 'next-i18next'

import { routes } from 'routes'
import LinkAnchor from 'components/LinkAnchor'

export default function BackToLogin() {
  const { t } = useTranslation()
  return (
    <p css={{ textAlign: 'center' }}>
      <LinkAnchor
        size="small"
        alignSelf="center"
        weight="normal"
        href={routes.login}
        label={t('cta.back-to-login')}
      />
    </p>
  )
}
